<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('events.index')">Events</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('events.show', [eventInfo.id])">{{ eventInfo.name }}</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('attendee-import.index', [eventInfo.id])">Import Attendees</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      Batch #{{ batch.id }}
    </h1>

    <div class="mb-6 flex justify-end items-center">
      <button class="btn-red" tabindex="-1" type="button" @click="destroy">Delete Batch</button>
    </div>

    <table-wrapper :headers="['Given Name', 'Surname', 'Contact Fields', 'Attendee Fields']" :text-wrap="false" class="mb-4">
      <table-row v-for="record in records" :key="record.id">
        <table-cell :href="route('attendees.edit', [record.attendee_id])">{{ record.given_name }}</table-cell>
        <table-cell :href="route('attendees.edit', [record.attendee_id])">{{ record.surname }}</table-cell>
        <table-cell :href="route('attendees.edit', [record.attendee_id])">
          <ul class="list-disc list-inside">
            <li v-for="(fieldVal, fieldName) in record.contact_fields" :key="fieldName">
              <span class="font-semibold">{{ fieldName }}:</span> {{ fieldVal }}
            </li>
          </ul>       
        </table-cell>
        <table-cell :href="route('attendees.edit', [record.attendee_id])">
          <ul class="list-disc list-inside">
            <li v-for="(fieldVal, fieldName) in record.attendee_fields" :key="fieldName">
              <span class="font-semibold">{{ fieldName }}:</span> {{ fieldVal }}
            </li>
          </ul>       
        </table-cell>
        <table-cell-end :href="route('attendees.edit', [record.attendee_id])"></table-cell-end>
      </table-row>
    </table-wrapper>

    <div class="mb-6 flex justify-end items-center">
      <button class="btn-red" tabindex="-1" type="button" @click="destroy">Delete Batch</button>
    </div>

  </div>
</template>

<script>
import Layout from "@/Shared/Layout"
import Icon from "@/Shared/Icon"
import TableWrapper from "@/Shared/Table/TableWrapper"
import TableRow from "@/Shared/Table/TableRow"
import TableCell from "@/Shared/Table/TableCell"
import TableCellEnd from "@/Shared/Table/TableCellEnd"
import Steps from "./ImportSteps"

export default {
  metaInfo: { title: "Import Complete" },
  components: {
    Icon,
    TableWrapper,
    TableRow,
    TableCell,
    TableCellEnd,
    Steps,
  },
  layout: Layout,
  props: {
    batch: Object,
    eventInfo: Object,
    records: Array,
  },
  data() {
    return {
    }
  },
  watch: {
  },
  methods: {
    importAttendees() {
      this.$inertia.put(this.route('attendee-import-review.update', [this.batch.id]));
    },
    destroy() {
      if (confirm('Are you sure you want to delete this attendee import batch?')) {
        this.$inertia.delete(this.route('attendee-import.destroy', [this.batch.id]))
      }
    },
  },
}
</script>